import { ref } from '@vue/composition-api';
import { useConfigStore } from '@/store/config';
import { qryUserQualLogStat, QryUserQualLogStatOrderType, QryUserQualLogStatQualTypeItem } from '@tencent/wphk-act-base-cgi';
import { getMonthPeriod, getServerTime } from '@/utils/date-helper';
import dayjs from 'dayjs';
import { to } from '@tencent/wphk-base-utils';

export const useTaskLastMonth = () => {
  /** 上月是否有进行印花兑换 */
  const hasLastMonthExchange = ref(false);
  const configStore = useConfigStore();

  /** 上月是否有进行印花兑换 */
  const hasLastMonthQualExchange = async (qualId: string) => {
    const serverTime = getServerTime();
    const lastMonth = dayjs(serverTime).subtract(1, 'month')
      .toDate();
    const { firstDate, lastDate } = getMonthPeriod(lastMonth);
    const [err, res] = await to(qryUserQualLogStat({
      // 因为来自配置的qualId已经是encode的，避免到时候请求时发生二次encode，这里先decode一下
      qualId: decodeURIComponent(qualId),
      startTime: firstDate,
      endTime: lastDate,
      orderType: QryUserQualLogStatOrderType.EXCHANGE,
      qualTypeList: [QryUserQualLogStatQualTypeItem.STAMP],
    }));
    // 如果err, 默认兜底是不展示推荐弹窗
    return !!res?.count || !!err;
  };

  async function init() {
    const { stampId } = configStore.config.commonConfig.stampConfig;
    hasLastMonthExchange.value = await hasLastMonthQualExchange(stampId); // 上月是否有兑换记录
  }
  return {
    hasLastMonthExchange,
    init,
  };
};
